import {
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";
import InfoSection from "@quest_editor/components/InfoSection";
import { Promotion } from "@quest_editor/mocks";

const PromotionInfoSection = ({
  promotion,
  getTypeLabel,
  buildOptionsDisplay,
  onCopyUrl,
}: {
  promotion: Promotion;
  getTypeLabel: (type: string) => string;
  buildOptionsDisplay: (promotion: Promotion | null | undefined) => string[];
  onCopyUrl: () => void;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("promotion_detail.section.info")}
      rightContent={
        <SubActionButton
          size="small"
          component={Link}
          to="edit"
        >
          {t("promotion_detail.button.edit")}
        </SubActionButton>
      }
      rows={[
        {
          label: t("promotion_detail.field.id"),
          children: (
            <Typography color="text.secondary">{promotion.id}</Typography>
          ),
        },
        {
          label: t("promotion_detail.field.name"),
          children: (
            <Typography color="text.secondary">{promotion.name}</Typography>
          ),
        },
        {
          label: t("promotion_detail.field.type"),
          children: (
            <Typography color="text.secondary">
              {getTypeLabel(promotion.type)}
            </Typography>
          ),
        },
        {
          label: t("promotion_detail.field.description"),
          children: (
            <Typography color="text.secondary">
              {promotion.description}
            </Typography>
          ),
        },
        {
          label: t("promotion_detail.field.options"),
          children: (
            <Stack direction="column" spacing={1}>
              {buildOptionsDisplay(promotion).map((opt, idx) => (
                <Typography key={idx} variant="body2" color="text.secondary">
                  {opt}
                </Typography>
              ))}
            </Stack>
          ),
        },
        {
          label: t("promotion_detail.field.return_url"),
          children: (
            <Stack direction="row" spacing={1} alignItems="center">
              <TextField size="small" value={promotion.returnUrl} fullWidth />
              <IconButton
                color="primary"
                aria-label={t("promotion_detail.button.copy")}
                onClick={onCopyUrl}
              >
                <ContentCopyIcon />
              </IconButton>
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default PromotionInfoSection;
